module.exports = __webpack_public_path__ + "img/spin-hand.b99e001d.webp";